export const extractDomainRegExp = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/\n]+)/i;
export const breakLink = maybeUrl => {
  let domain = 'website';
  let url = maybeUrl;
  const match = extractDomainRegExp.exec(maybeUrl);
  if (match) {
    domain = match[1];
  }
  if (!maybeUrl.match(/https?:/)) {
    url = `http://${maybeUrl}`;
  }
  return {
    url,
    domain
  };
};
/**
 * Force the compiler to narrow the type of a value to a specific type.
 * 
 * @example
 * ```ts
 * const element = document.querySelector('.some-selector');
 * // typeof element is `Element | null`
 * blindAssert<HTMLDivElement>(element);
 * // typeof element is `HTMLDivElement`
 * ```
 * 
 * In reality acts like the & operator. Existing type information is NOT lost.
 * @example 
 * ```
 * const element = document.querySelector('.some-selector');
 * // typeof element is `Element | null`
 * blindAssert<number>(element);
 * // typeof element is Element & number <--- we can't arbitrarily set the type
 * ```
 * It should also be noted that attempting to assert an incompatibly type may have
 * undesired effects.
 * @example
 * ```ts
 * const value = 5;
 * // typeof value is `number`
 * blindAssert<boolean>(value);
 * // typeof value is `never` <---- because `number & boolean` simplifies to never
 * ```
 */
export function blindAssert(value) {}